// eslint-disable-next-line import/no-anonymous-default-export
export default {
  user: {},
  token: "",
  language: "en",
  loginExpired: false,
  modalTrigger: false,
  errorText: "",
  errorCode: 0,
  floatSpinner: false,
  accessFromInternet: false,
};
